import { NavBar, Form, Button, Input, Toast, Selector } from 'antd-mobile'
import React, { useState } from 'react'
import '../../styles/pages/dinner-form.css'
import { useLocation } from 'react-router-dom'
import { DINNER_PAY_OPTIONS } from '../dinnerStatus';
import { dinnerApi } from '../../features/dinner/api/dinnerApi';

export default function UpdateDinner() {

    const location = useLocation();
    const dinnerInfo = location.state.dinnerInfo;
    const [buttomLoading, setButtomLoading] = useState(false)

    const createGamefunc = (values) => {
        Toast.show({
            icon: 'loading',
            duration: 0,
        })
        setButtomLoading(true)

        dinnerApi.update({
            dinnerId: dinnerInfo.id,
            position: values.position,
            remark: values.gameRemark,
            lat: 0,
            lng: 0,
            status: values.status[0]
        })
            .then(function (response) {
                if (response.data.code === 200) {
                    Toast.show({
                        content: '修改成功！',
                        icon: 'success',
                        afterClose: () => {
                            window.history.back();
                        },
                    })
                } else {
                    Toast.show({
                        content: response.data.msg,
                        icon: 'fail'
                    })
                }
            })
            .catch(function () {
                Toast.show({
                    content: '修改失败,请重试!',
                    icon: 'fail'
                })
            })
            .finally(() => {
                setButtomLoading(false)
            });
    }

    return (
        <div className="dinner-form-scope dinner-form-container has-unified-nav">
            <NavBar className="unified-navbar fixed" onBack={() => window.history.back()}>
                编辑聚餐活动
            </NavBar>

            <div className="glass-form-card">
                <div className="form-header-premium">
                    <span className="form-header-icon">✏️</span>
                    <span className="form-header-title">编辑聚餐</span>
                </div>

                <Form
                    className="dinner-form-premium"
                    name='form'
                    onFinish={(values) => createGamefunc(values)}
                    initialValues={{
                        position: dinnerInfo.position,
                        gameRemark: dinnerInfo.remark,
                        status: [dinnerInfo.status],
                    }}
                    footer={
                        <div className="form-footer-premium">
                            <Button
                                block
                                type='submit'
                                className="submit-btn-premium"
                                loading={buttomLoading}
                            >
                                保存并更新计划
                            </Button>
                        </div>
                    }
                >
                    <Form.Item name='position' label='📍 聚餐地点' rules={[{ required: true, message: '请填写地点' }]}>
                        <Input placeholder='输入餐厅或地点名称...' />
                    </Form.Item>

                    <Form.Item name='gameRemark' label='📝 备注信息' >
                        <Input placeholder='备注聚餐详情（可选）...' />
                    </Form.Item>

                    <Form.Item name='status' label='💰 支付方式' >
                        <Selector
                            columns={2}
                            options={DINNER_PAY_OPTIONS}
                        />
                    </Form.Item>
                </Form>
            </div>
        </div >
    )
}
